import { Box, Button, Card, Stack, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { MenuItem, Select } from "@mui/material";


import Body from "../../ui/Body";



export default function Editconfigmeta() {
  const [configData, setConfigData] = useState({});
  const [configId, setConfigId] = useState(null)
  const navigate = useNavigate();
  const [loadData, setLoadData] = useState(false)

  const [AmountDate, setAmountDate] = useState(null)

  const onChangeHandler = (e) => {
    setConfigData({ ...configData, [e.target.id]: e.target.value });
  };
  const onChangeEditorHandler = (e) => {
    setConfigData({ ...configData, redeem_rules: e });
  }


  useEffect(() => {
    const fetchConfigMeta = () => {
      setLoadData(true)
      axios.get("/admin/config-meta").then((res) => {
        // console.log("res===>",res.data.status_code)
        if (res.data.status_code == 401) {
          localStorage.clear()
        }
        if (res.status == 200) {
          let data = res.data.response;
          setConfigId(data._id)
          setConfigData(data);
          // console.log("data-->", data);
          if (data.is_voucher_uploading) {
            data.is_voucher_uploading = "true"
          } else {
            data.is_voucher_uploading = "false"
          }
          if (data.qwik_redeem_feature_status) {
            data.qwik_redeem_feature_status = "true"
          } else {
            data.qwik_redeem_feature_status = "false"
          }
          if (data.ka_redeem_feature_status) {
            data.ka_redeem_feature_status = true
          } else {
            data.ka_redeem_feature_status = false
          }
          if (data.coupon_redeem_feature_status) {
            data.coupon_redeem_feature_status = "true"
          } else {
            data.coupon_redeem_feature_status = "false"
          }
          if (data.phonepe_enabled) {
            data.phonepe_enabled = "true"
          } else {
            data.phonepe_enabled = "false"
          }
          if (data.is_qwik_product_show) {
            data.is_qwik_product_show = "true"
          } else {
            data.is_qwik_product_show = "false"
          }

          if (data.free_cash_enabled) {
            data.free_cash_enabled = "true"
          } else {
            data.free_cash_enabled = "false"
          }

          if (data.upi_redeem_feature_status) {
            data.upi_redeem_feature_status = "true"
          } else {
            data.upi_redeem_feature_status = "false"
          }

          if (data.is_upi_voucher_uploading) {
            data.is_upi_voucher_uploading = "true"
          } else {
            data.is_upi_voucher_uploading = "false"
          }

          if (data.coupon_discount_master_enabled === false || data.coupon_discount_master_enabled === "false") {
            data.coupon_discount_master_enabled = "false"
          } else {
            data.coupon_discount_master_enabled = "true"
          }

          console.log("data", data)
        }
      });
      setLoadData(false)
    };
    fetchConfigMeta();
  }, []);

  const updateHandler = () => {
    // console.log("configData1", configData)

    let obj = { ...configData };
    // console.log("configData2", configData._id)

    obj.config_id = configId;
    // console.log("obj yes yes-->", obj);
    if (is_voucher_uploading && is_voucher_uploading == "true") {
      obj.is_voucher_uploading = true;
    }
    if (is_voucher_uploading && is_voucher_uploading == "false") {
      obj.is_voucher_uploading = false;
    }
    if (qwik_redeem_feature_status && qwik_redeem_feature_status == "true") {
      obj.qwik_redeem_feature_status = true;
    }
    if (qwik_redeem_feature_status && qwik_redeem_feature_status == "false") {
      obj.qwik_redeem_feature_status = false;
    }
    if (ka_redeem_feature_status && ka_redeem_feature_status == "true") {
      obj.ka_redeem_feature_status = true;
    }
    if (ka_redeem_feature_status && ka_redeem_feature_status == "false") {
      obj.ka_redeem_feature_status = false;
    }

    if (is_qwik_product_show && is_qwik_product_show == "false") {
      obj.is_qwik_product_show = false;
    }
    if (is_qwik_product_show && is_qwik_product_show == "true") {
      obj.is_qwik_product_show = true;
    }
    if (coupon_redeem_feature_status && coupon_redeem_feature_status == "false") {
      obj.coupon_redeem_feature_status = false;
    }
    if (coupon_redeem_feature_status && coupon_redeem_feature_status == "true") {
      obj.coupon_redeem_feature_status = true;
    }
    // if (is_qty_increase && is_qty_increase == "False") {
    //   obj.is_qty_increase = false;
    // }
    // if (is_qty_increase && is_qty_increase == "True") {
    //   obj.is_qty_increase = true;
    // }
    if (is_qwik_product_show && is_qwik_product_show == "false") {
      obj.is_qty_increase = false;
    }
    if (is_qwik_product_show && is_qwik_product_show == "true") {
      obj.is_qwik_product_show = true;
    }

    if (phonepe_enabled && phonepe_enabled == "false") {
      obj.phonepe_enabled = false;
    }
    if (phonepe_enabled && phonepe_enabled == "true") {
      obj.phonepe_enabled = true;
    }

    if (free_cash_enabled && free_cash_enabled == "false") {
      obj.free_cash_enabled = false;
    }
    if (free_cash_enabled && free_cash_enabled == "true") {
      obj.free_cash_enabled = true;
    }


    if (upi_redeem_feature_status && upi_redeem_feature_status == "false") {
      obj.upi_redeem_feature_status = false;
    }
    if (upi_redeem_feature_status && upi_redeem_feature_status == "true") {
      obj.upi_redeem_feature_status = true;
    }

    if (is_upi_voucher_uploading && is_upi_voucher_uploading == "false") {
      obj.is_upi_voucher_uploading = false;
    }
    if (is_upi_voucher_uploading && is_upi_voucher_uploading == "true") {
      obj.is_upi_voucher_uploading = true;
    }

    if (coupon_discount_master_enabled && coupon_discount_master_enabled == "false") {
      obj.coupon_discount_master_enabled = false;
    }
    if (coupon_discount_master_enabled && coupon_discount_master_enabled == "true") {
      obj.coupon_discount_master_enabled = true;
    }

    if (AmountDate != null) {
      var date = new Date(AmountDate); // Or the date you'd like converted.
      var DateTime = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
      DateTime.setUTCHours(0, 0, 0, 0);
      let isoDateTime = DateTime.toISOString();
      obj.extended_amount_date = isoDateTime
    }

    // if (redeem_feature_status && redeem_feature_status == "true") {
    //   obj.redeem_feature_status = true;
    // }
    // if (redeem_feature_status && redeem_feature_status == "false") {
    //   obj.redeem_feature_status = false;
    // }

    //   if (convert_mints_feature_status && convert_mints_feature_status == "true") {
    //     obj.redeem_feature_status = true;
    //   }
    //   if (convert_mints_feature_status && convert_mints_feature_status == "false") {
    //     obj.convert_mints_feature_status = false;
    //   }
    console.log("____>", obj)
    axios.put("/admin/config-meta", obj).then((res) => {
      //console.log(res);
      navigate("/configmeta");
    });
  };
  const {
    app_version,
    redeem_gc,
    redeem_amount,
    is_voucher_uploading,
    payment_count,
    ka_auth_mobile,
    ka_auth_password,
    qwikcilver_client_key,
    qwikcilver_client_secret,
    qwikcilver_user_id,
    qwikcilver_password,
    qwikcilver_base_url,
    qwik_redeem_feature_status,
    ka_redeem_feature_status,
    coupon_redeem_feature_status,
    available_ka_redeem_count,
    available_co_redeem_count,
    available_qw_redeem_count,
    is_qwik_product_show,
    chat_support_number,
    tpx_co_order_limit,
    phonepe_enabled,
    free_cash_enabled,

    // is_qty_increase,
    // popular_voucher_count,

    redeem_rules,
    available_cash_ka_redeem_count,
    available_cash_co_redeem_count,
    available_cash_qw_redeem_count,
    otp_send_attempts,
    otp_send_reset_hours,
    otp_varify_attempts,
    tpx_ka_order_limit,
    tpx_qw_order_limit,
    order_failed_limit,
    upi_redeem_feature_status,
    is_upi_voucher_uploading,
    pro_voucher_order_limit,
    pro_order_amount_limit,

    daily_slots,
    daily_slot_order_amount_limit,
    extended_amount_in_slot_no,
    extended_amount_date,
    daily_slot_order_amount_extended_limit,
    coupon_discount_master_enabled,

  } = configData;

  if (loadData) {
    return (
      <Typography>Loading....</Typography>
    )
  } else {
    return (

      <>
        <Sidebar />
        <Nabvar />
        {/* body */}
        <Body>
          <Card sx={{ p: 4 }}>
            <Stack spacing={2}>

              <Typography> App version :</Typography>
              <TextField
                fullWidth
                type="text"
                className="rounded  py-2"
                id="app_version"
                value={app_version}
                onChange={onChangeHandler}
                placeholder="Enter App version"
              />


              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>Is Vouchar Uploading :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={is_voucher_uploading == "true" ? true : false}
                  className="rounded  py-2"
                  value={'true'}
                  onChange={(e) => { setConfigData({ ...configData, is_voucher_uploading: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={is_voucher_uploading == "false" ? true : false}
                  className="rounded  py-2"
                  value={'false'}
                  onChange={(e) => { setConfigData({ ...configData, is_voucher_uploading: e.target.value }) }}
                />False
              </Stack>


              {/* <Typography>Popular voucher Count :</Typography>
              <TextField
                fullWidth
                type="text"
                className="rounded  py-2"
                id="popular_voucher_count"
                value={popular_voucher_count}
                onChange={onChangeHandler}
              /> */}


              <Typography>Redeeem Rules :</Typography>
              <ReactQuill theme="snow" value={redeem_rules} onChange={onChangeEditorHandler} />



              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>Qwik redeem Feature Status :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={qwik_redeem_feature_status == "true" ? true : false}
                  className="rounded  py-2"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, qwik_redeem_feature_status: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={qwik_redeem_feature_status == "false" ? true : false}
                  className="rounded  py-2"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, qwik_redeem_feature_status: e.target.value }) }}
                />False
              </Stack>


              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>ka Redeem Feature Status :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={ka_redeem_feature_status == "true" ? true : false}
                  className="rounded  py-2"
                  name="ka_redeem_feature_status"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, ka_redeem_feature_status: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={ka_redeem_feature_status == "false" ? true : false}
                  className="rounded  py-2"
                  name="ka_redeem_feature_status"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, ka_redeem_feature_status: e.target.value }) }}
                />False
              </Stack>



              <Typography>KA Cash Payment Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                id="available_cash_ka_redeem_count"
                min="0"
                value={available_cash_ka_redeem_count}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                onChange={onChangeHandler}
              />


              <Typography>QC Cash Payment Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                id="available_cash_qw_redeem_count"
                min="0"
                value={available_cash_qw_redeem_count}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                onChange={onChangeHandler}
              />


              <Typography>GP Cash Payment Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                id="available_cash_co_redeem_count"
                min="0"
                value={available_cash_co_redeem_count}
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                onChange={onChangeHandler}
              />





              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>Coupon Redeem Feature Status :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={coupon_redeem_feature_status == "true" ? true : false}
                  className="rounded  py-2"
                  name="coupon_redeem_feature_status"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, coupon_redeem_feature_status: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={coupon_redeem_feature_status == "false" ? true : false}
                  className="rounded  py-2"
                  name="coupon_redeem_feature_status"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, coupon_redeem_feature_status: e.target.value }) }}
                />False
              </Stack>


              <Typography>KA GC Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                id="available_ka_redeem_count"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                value={available_ka_redeem_count}
                onChange={onChangeHandler}
              />


              <Typography>GP GC Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                id="available_co_redeem_count"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                value={available_co_redeem_count}
                onChange={onChangeHandler}
              />


              <Typography>KA QC Redeem Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="available_qw_redeem_count"
                value={available_qw_redeem_count}
                onChange={onChangeHandler}
              />


              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography> Is Qwik Product Show :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={is_qwik_product_show == "true" ? true : false}
                  className="rounded  py-2"
                  name="is_qwik_product_show"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, is_qwik_product_show: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={is_qwik_product_show == "false" ? true : false}
                  className="rounded  py-2"
                  name="is_qwik_product_show"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, is_qwik_product_show: e.target.value }) }}
                />False
              </Stack>

              <Typography>OTP Send Attempts :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="otp_send_attempts"
                value={otp_send_attempts}
                onChange={onChangeHandler}
              />


              <Typography>OTP Send Reset Hours :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="otp_send_reset_hours"
                value={otp_send_reset_hours}
                onChange={onChangeHandler}
              />


              <Typography>OTP varify attempts :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="otp_varify_attempts"
                value={otp_varify_attempts}
                onChange={onChangeHandler}
              />


              <Typography>chat_support_number :</Typography>
              <TextField
                fullWidth
                type="text"
                className="rounded  py-2"
                // min="0"
                // onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="chat_support_number"
                value={chat_support_number}
                onChange={onChangeHandler}
              />

              <Typography>tpx_ka_order_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="tpx_ka_order_limit"
                value={tpx_ka_order_limit}
                onChange={onChangeHandler}
              />


              <Typography>tpx_co_order_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="tpx_co_order_limit"
                value={tpx_co_order_limit}
                onChange={onChangeHandler}
              />

              <Typography>tpx_co_order_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="tpx_qw_order_limit"
                value={tpx_qw_order_limit}
                onChange={onChangeHandler}
              />

              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>phonepe_enabled :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={phonepe_enabled == "true" ? true : false}
                  className="rounded  py-2"
                  name="phonepe_enabled"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, phonepe_enabled: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={phonepe_enabled == "false" ? true : false}
                  className="rounded  py-2"
                  name="phonepe_enabled"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, phonepe_enabled: e.target.value }) }}
                />False
              </Stack>


              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>free_cash_enabled :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={free_cash_enabled == "true" ? true : false}
                  className="rounded  py-2"
                  name="free_cash_enabled"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, free_cash_enabled: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={free_cash_enabled == "false" ? true : false}
                  className="rounded  py-2"
                  name="free_cash_enabled"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, free_cash_enabled: e.target.value }) }}
                />False
              </Stack>

              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>upi_redeem_feature_status :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={upi_redeem_feature_status == "true" ? true : false}
                  className="rounded  py-2"
                  name="upi_redeem_feature_status"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, upi_redeem_feature_status: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={upi_redeem_feature_status == "false" ? true : false}
                  className="rounded  py-2"
                  name="upi_redeem_feature_status"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, upi_redeem_feature_status: e.target.value }) }}
                />False
              </Stack>

              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>is_upi_voucher_uploading :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={is_upi_voucher_uploading == "true" ? true : false}
                  className="rounded  py-2"
                  name="is_upi_voucher_uploading"
                  value={'true'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, is_upi_voucher_uploading: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={is_upi_voucher_uploading == "false" ? true : false}
                  className="rounded  py-2"
                  name="is_upi_voucher_uploading"
                  value={'false'}
                  onChange={(e) => { console.log(e.target.value); setConfigData({ ...configData, is_upi_voucher_uploading: e.target.value }) }}
                />False
              </Stack>

              <Stack direction='row' spacing={2} alignItems='center'>
                <Typography>Coupon Discount Kill Switch :</Typography>
                <input
                  fullWidth
                  type="radio"
                  checked={coupon_discount_master_enabled == "true" ? true : false}
                  className="rounded  py-2"
                  name="coupon_discount_master_enabled"
                  value={'true'}
                  onChange={(e) => { setConfigData({ ...configData, coupon_discount_master_enabled: e.target.value }) }}
                />True
                <input
                  fullWidth
                  type="radio"
                  checked={coupon_discount_master_enabled == "false" ? true : false}
                  className="rounded  py-2"
                  name="coupon_discount_master_enabled"
                  value={'false'}
                  onChange={(e) => { setConfigData({ ...configData, coupon_discount_master_enabled: e.target.value }) }}
                />False
              </Stack>


              <Typography>Order Failed Limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="order_failed_limit"
                value={order_failed_limit}
                onChange={onChangeHandler}
              />

              {/* <Typography>pro_order_amount_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="pro_order_amount_limit"
                value={pro_order_amount_limit}
                onChange={onChangeHandler}
              />

              <Typography>pro_voucher_order_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="pro_voucher_order_limit"
                value={pro_voucher_order_limit}
                onChange={onChangeHandler}
              /> */}


              <Typography>daily_slots :</Typography>
              {/* <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="daily_slots"
                value={daily_slots}
                onChange={onChangeHandler}
              /> */}


              <Select
                fullWidth
                value={daily_slots}
                onChange={(e) => setConfigData({ ...configData, daily_slots: e.target.value })}
              >
                {[1, 2, 3, 4, 6, 8, 12, 24].map((val) => (
                  <MenuItem key={val} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>


              <Typography>daily_slot_order_amount_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="daily_slot_order_amount_limit"
                value={daily_slot_order_amount_limit}
                onChange={onChangeHandler}
              />



              <Typography>extended_amount_in_slot_no :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="extended_amount_in_slot_no"
                value={extended_amount_in_slot_no}
                onChange={onChangeHandler}
              />


              <Typography>daily_slot_order_amount_extended_limit :</Typography>
              <TextField
                fullWidth
                type="number"
                className="rounded  py-2"
                min="0"
                onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                id="daily_slot_order_amount_extended_limit"
                value={daily_slot_order_amount_extended_limit}
                onChange={onChangeHandler}
              />


              <Typography>extended_amount_date :</Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    label="Amount Date"
                    value={extended_amount_date ? dayjs(extended_amount_date) : null}
                    onChange={(newValue) => { console.log(newValue); setAmountDate(newValue)}}
                  />
                </DemoContainer>
              </LocalizationProvider>

              <Box>
                <Button variant="contained" sx={{ mt: 2 }} onClick={updateHandler} bgClr="#4CAF50">Update</Button>
              </Box>
            </Stack>
          </Card>

        </Body>
      </>
    );
  }
}
